module.exports = __webpack_public_path__ + "img/down.423d05ff.svg";